import { Api } from "@/api";
import { Url } from "@/helpers/url";
import { t } from "i18next";
import { Context } from "./context";
import { createContext } from "preact";

export type Breadcrumb = {
  url: string;
  label: string;
};

export class Breadcrumbs {
  breadcrumbs: Breadcrumb[] = [];

  constructor(
    protected context: Context,
    protected api: Api,
  ) { }

  update = () => {
    this.context.notify("breadcrumbs");
  };

  setBreadcrumb = (breadcrumb: Breadcrumb, forceOverride = false) => {
    if (forceOverride) {
      this.setBreadcrumbs([breadcrumb]);
      return;
    }
    const currentIndex = this.breadcrumbs.findIndex(({ label }) => label === breadcrumb.label);
    if (currentIndex !== -1) {
      this.breadcrumbs = this.breadcrumbs.slice(0, currentIndex);
      this.update();
      return;
    }

    this.breadcrumbs = [...this.breadcrumbs, breadcrumb];
    this.update();
  };

  setBreadcrumbs = (breadcrumbs: Breadcrumb[]) => {
    this.breadcrumbs = [this.firstBreadcrumb, ...breadcrumbs];
    this.update();
  };

  get firstBreadcrumb() {
    return {
      url: Url.to("home-page-with-lang"),
      label: t("j60wdc57kcnq57wt.home-page", "Home page"),
    };
  }

  get backUrl() {
    return this.breadcrumbs.length > 1 ? this.breadcrumbs[this.breadcrumbs.length - 2].url : this.firstBreadcrumb.url;
  }

  clearBreadcrumb = () => {
    this.breadcrumbs = [];
  };
}

export const BreadcrumbsContext = createContext<Breadcrumbs>("Breadcrumbs");
